import AppHeaderComponent from './AppHeader';

const AppHeader = AppHeaderComponent;
  
export default AppHeader;
